module.exports = __webpack_public_path__ + "static/img/ic_serviceflow_e.a4985a30.png";